<template>
  <Teleport
    v-if="oc.visible.value"
    to="body"
  >
    <div
      :id="`off-canvas-container-${oc.content.value?.id}`"
      class="dynamic-component"
    >
      <div
        :id="`shield-${oc.content.value?.id}`"
        class="shield"
        @click="close"
      />

      <div
        :id="oc.content.value?.id"
        class="off-canvas shadow-lg dynamic-component"
        :style="`width: ${oc.content.value?.width}px;`"
      >
        <div class="off-canvas-header relative">
          <h2 class="text-white">
            {{ oc.content.value?.title }}
          </h2>

          <div
            class="close cursor-pointer"
            @click="close"
          >
            <i class="fas fa-times-circle" />
          </div>
        </div>

        <div
          class="content"
          @click.stop
        >
          <component
            :is="oc.content.value?.component"
            v-bind="oc.content.value?.props"
            @action-complete="close"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { useOffCanvas } from '~/composables/useOffCanvas';
import { watch, nextTick } from 'vue';

export default {
  name: 'OffCanvasRoot',

  setup() {
    const oc = useOffCanvas();

    const addSlideIn = () => {
      const cid = oc.content.value?.id;
      const container = cid
          ? document.getElementById(`off-canvas-container-${cid}`)
          : null;

      if (container) container.classList.add('slide-in');
    };

    const removeSlideIn = () => {
      const cid = oc.content.value?.id;
      const container = cid
          ? document.getElementById(`off-canvas-container-${cid}`)
          : null;

      if (container) container.classList.remove('slide-in');
    };

    const close = () => {
      removeSlideIn();

      setTimeout(() => {
        oc.hide();
      }, 500);
    };

    watch(
        () => oc.visible.value,
        async (val) => {
          if (val) {
            await nextTick();
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                addSlideIn();
              });
            });
          } else {
            removeSlideIn();
          }
        }
    );

    const handleEscape = (e) => {
      if (e.key === 'Escape') close();
    };

    return {
      oc,
      close,
      handleEscape
    };
  },

  mounted() {
    window.addEventListener('keydown', this.handleEscape);
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.handleEscape);
  }
};
</script>

<style scoped lang="scss">
$menuBg: var(--off-canvas-bg);
$headerType: var(--off-canvas-text);

.shield {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.4);
}

.off-canvas {
  background-color: #fff;
  position: fixed;
  top: 0;
  right: -50%;
  height: 100%;
  z-index: 100;
  overflow: hidden;

  /* FIX: remove the delay */
  transition: right 0.4s ease-in-out;

  @media (max-width: 1000px) {
    width: 100% !important;
  }

  .off-canvas-header {
    padding: 20px 50px 20px 20px;
    background-color: $menuBg;
    color: $headerType;
  }

  .content {
    height: calc(100% - 50px);
    overflow-y: auto;
    padding: 20px 30px 100px 30px;
    min-width: 420px;
  }
}

.slide-in .off-canvas {
  right: 0;
}

.close {
  position: absolute;
  top: 25px;
  right: 20px;
  font-size: 20px;
}
</style>
